import { render } from "./KpiHeader.vue?vue&type=template&id=722eae50&scoped=true"
import script from "./KpiHeader.vue?vue&type=script&lang=js"
export * from "./KpiHeader.vue?vue&type=script&lang=js"

import "./KpiHeader.vue?vue&type=style&index=0&id=722eae50&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722eae50"]])

export default __exports__